import { render } from "./warehouse-modal.vue?vue&type=template&id=5486433a&ts=true"
import script from "./warehouse-modal.vue?vue&type=script&lang=ts"
export * from "./warehouse-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__